<template>
  <div>
    <el-input
        v-model="tempModel"
        autocomplete="off"
        placeholder="请选择岗位"
        :disabled="disabled == null ? false : disabled"
        @focus="openPerson"
        @click="openPerson"
    ></el-input>
    <!-- 岗位列表弹窗 -->

    <el-drawer
        v-model="dialogFormVisiblePerson"
        title="岗位列表"
        size="20%"
        append-to-body
    >
      <el-table
          :data="tableDataPerson"
          style="width: 100%; margin-left: 2.5%; background-color: #e9eef3"
          v-fit-columns
          ref="MultiplePerson"
          border
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="postName" label="岗位名称" width="" />
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import { getPost } from "../../../request/BasicDataApi";

export default {
  name: "single select",

  data() {
    return {
      list: [],
      tableDataPerson: [],
      dialogFormVisiblePerson: false, //岗位弹窗
      tempModel: null,
    };
  },
  props: ["model", "disabled", "departId"],
  created() {
    getPost({
      pageNum: 1,
      pageSize: 100,
      postName: "",
      departId: this.departId,
    })
        .then((res) => {
          console.log(res);
          console.log("000");
          if (res.code == 0) {
            this.tableDataPerson = res.data;
          }
        })
        .then(() => {
          this.tableDataPerson.forEach((item, index) => {
            item.rowIndex = index;
          });
        });
  },
  methods: {
    //选择责任人
    handleCurrentChange(e) {
      this.dialogFormVisiblePerson = false;
    },
    //打开人员列表弹窗
    openPerson() {
      this.dialogFormVisiblePerson = true;
    },
    handleSelectionChange(val) {
      if (this.dialogFormVisiblePerson) {
        let idArr = [];
        let nameArr = [];
        val.forEach((item) => {
          idArr.push(item.id);
          nameArr.push(item.postName);
        });
        this.$emit("id", idArr.join(","));
        this.$emit("name", nameArr.join(","));
      }
    },
  },
  watch: {
    departId(e) {
      getPost({ pageNum: 1, pageSize: 100, postName: "", departId: e })
          .then((res) => {
            if (res.code == 0) {
              this.tableDataPerson = res.data;
            }
          })
          .then(() => {
            this.tableDataPerson.forEach((item, index) => {
              item.rowIndex = index;
            });
          });
    },

    dialogFormVisiblePerson(e) {
      if (!e) {
        this.$refs["MultiplePerson"].clearSelection();
      }
    },
    'model'(e){
      this.tempModel = e
    },
  },
};
</script>

<style scoped>
</style>
